module.exports = __webpack_public_path__ + "media/images/universe_landing_pages/hero_banner/component/cleaning-desktop@2x-6a5e96c025a258fd475aaf6d009d9e47.jpg";